import { useEffect, useCallback } from 'react';
import useTokenStore from '../store/store';
import useUserProfileStore from '../store/userProfileStore';
import { fetchUserProfile } from '../utils/user';

export const useUserProfile = () => {
  const token = useTokenStore((state) => state.token);
  const { profile, loading, error, setProfile, setLoading, setError, clearProfile } = useUserProfileStore();

  const fetchProfile = useCallback(async () => {
    if (!token) {
      clearProfile();
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const profileData = await fetchUserProfile(token);
      if (profileData) {
        // Transform the API response to match our UserProfile interface
        const transformedProfile = {
            _id: '', 
            firstName: profileData.firstName,
            lastName: profileData.lastName,
            email: profileData.email,
            phone: profileData.phone,
            userHandle: profileData.userHandle,
            connectedTo: profileData.connectedTo,
            verified: profileData.verified || true,
            status: profileData.status || true,
            createdAt: profileData.createdAt || new Date().toISOString(),  
            updatedAt: profileData.updatedAt || new Date().toISOString(),
            // Add deletion-related fields
            deletionRequested: profileData.deletionRequested || false,
            deletionRequestedAt: profileData.deletionRequestedAt,
            deletionScheduledFor: profileData.deletionScheduledFor,
            deletionCancellationToken: profileData.deletionCancellationToken,
            accountStatus: profileData.accountStatus || 'active'
        };
        setProfile(transformedProfile);
      } else {
        setError('Failed to fetch profile data');
      }
    } catch (err) {
      setError('Failed to fetch profile data');
      console.error('Error fetching user profile:', err);
    }
  }, [token, clearProfile, setLoading, setError, setProfile]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return {
    profile,
    loading,
    error,
    refetch: fetchProfile,
  };
}; 